module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "epigraph",
    attrs: {
      "epub:type": "epigraph"
    }
  }, [_c('blockquote', {
    staticClass: " bq"
  }, [_c('p', {
    staticClass: "margin_top_epigraph firstInSection"
  }, [_vm._v("Love constitutes a great human interest, of course. Money has an appeal as strong or sometimes even stronger. Then there is death, horrid enough one might think, yet capable like the rest of being turned for the occasion into an unwilling pay box attendant.")])]), _vm._v(" "), _c('p', {
    staticClass: "align_right firstInSection"
  }, [_c('em', [_vm._v("The Handbook of Kinematography")]), _vm._v(" Colin N. Bennett, F.C.S. and collaborators (London: "), _c('em', [_vm._v("Kinematograph Weekly")]), _vm._v(", 1911).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed0ea44a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 66
// module chunks = 0